<h3>Viewing CPD Session for {{ returnSessionBannerTitle() }}. <br> Close this tab to return to your CPD session</h3>
<fa-icon [icon]="['fal','times']" (click)="close()"></fa-icon>
